import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_dsm/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_dsm/layout/core'
import {MasterInit} from '../_dsm/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth/core/Auth'

const App = () => {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <I18nProvider>
                <LayoutProvider>
                    <AuthInit>
                        <Outlet/>
                        <MasterInit/>
                    </AuthInit>
                </LayoutProvider>
            </I18nProvider>
        </Suspense>
    )
}

export {App}
